import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaTrashAlt } from 'react-icons/fa';
import { updateCartQuantity, removeFromCart } from '../utils/cartUtils';
import { getImageUrl } from '../utils/imageUtils';
import './CartDrawer.css';

const CartDrawer = ({ isOpen, onClose, cartItems, setCartItems }) => {
  const totalPrice = cartItems.reduce((sum, item) => {
    const price = item.price || item.product?.price || 0;
    const quantity = item.quantity || 1;
    return sum + (price * quantity);
  }, 0);

  const handleQuantityChange = (itemId, change) => {
    const item = cartItems.find(i => i._id === itemId);
    if (!item) return;
    const newQuantity = item.quantity + change;
    if (newQuantity < 1) {
      setCartItems(removeFromCart(itemId));
      return;
    }
    setCartItems(updateCartQuantity(itemId, newQuantity));
  };

  const handleRemove = (itemId) => {
    setCartItems(removeFromCart(itemId));
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && <div className="cart-drawer-backdrop" onClick={onClose}></div>}

      {/* Drawer */}
      <div className={`cart-drawer ${isOpen ? 'open' : ''}`}>
        <div className="cart-drawer-header">
          <h2>Your Cart</h2>
          <button className="close-drawer-btn" onClick={onClose}>×</button>
        </div>

        <div className="cart-drawer-content">
          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <div className="empty-cart-icon" aria-hidden>
                <FaShoppingCart />
              </div>
              <p>Your cart is empty</p>
              <Link to="/market" className="continue-shopping-btn" onClick={onClose}>
                Continue Shopping
              </Link>
            </div>
          ) : (
            <>
              <div className="cart-items-list">
                {cartItems.map((item) => (
                  <div key={item._id} className="cart-item">
                    <div className="cart-item-image">
                      <img
                        src={getImageUrl(item.image || item.product?.image)}
                        alt={item.name || item.product?.name || 'Product'}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/deafultpic.png';
                        }}
                      />
                    </div>
                    <div className="cart-item-details">
                      <div className="cart-item-name-row">
                        <h4 className="cart-item-name">{item.name || item.product?.name}</h4>
                        <button
                          className="cart-drawer-remove-item-btn"
                          onClick={() => handleRemove(item._id)}
                          title="Remove item"
                        >
                          <FaTrashAlt aria-hidden />
                        </button>
                      </div>
                      <p className="cart-item-farmer">{(item.farmer?.name || item.product?.farmer?.name) || 'Farmer'}</p>
                      <div className="cart-item-price">Rs. {item.price || item.product?.price} / {item.unit || item.product?.unit}</div>
                    </div>
                    <div className="cart-item-actions">
                      <div className="quantity-controls">
                        <button
                          className="quantity-btn"
                          onClick={() => handleQuantityChange(item._id, -1)}
                        >
                          −
                        </button>
                        <span className="quantity-value">{item.quantity}</span>
                        <button
                          className="quantity-btn"
                          onClick={() => handleQuantityChange(item._id, 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-drawer-footer">
                <div className="cart-total">
                  <span>Total:</span>
                  <span className="total-price">Rs. {totalPrice.toFixed(2)}</span>
                </div>
                <Link to="/checkout" className="checkout-btn" onClick={onClose}>
                  Proceed to Checkout
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CartDrawer;

